// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-section {
  background: #f8f9fc;
}

.news-card {
  max-width: 700px;
  margin: auto;
  padding: 20px 25px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.news-ticker {
  height: 140px;
  overflow: hidden;
  position: relative;
}

.news-list {
  list-style: none;
  padding: 0;
  margin: 0;
  animation: scrollUp 14s linear infinite;
}

.news-ticker:hover .news-list {
  animation-play-state: paused;
}

.news-list li {
  display: flex;
  gap: 12px;
  padding: 10px 0;
  font-size: 0.95rem;
}

.news-date {
  min-width: 110px;
  font-weight: 600;
  color: #1e88e5;
}

.news-text {
  color: #333;
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/components/news.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,uCAAA;AACF;;AAEA;EACE,4BAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE;IACE,wBAAA;EACF;EACA;IACE,2BAAA;EACF;AACF","sourcesContent":[".news-section {\r\n  background: #f8f9fc;\r\n}\r\n\r\n.news-card {\r\n  max-width: 700px;\r\n  margin: auto;\r\n  padding: 20px 25px;\r\n  background: #fff;\r\n  border-radius: 8px;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n.news-ticker {\r\n  height: 140px;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.news-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n  animation: scrollUp 14s linear infinite;\r\n}\r\n\r\n.news-ticker:hover .news-list {\r\n  animation-play-state: paused;\r\n}\r\n\r\n.news-list li {\r\n  display: flex;\r\n  gap: 12px;\r\n  padding: 10px 0;\r\n  font-size: 0.95rem;\r\n}\r\n\r\n.news-date {\r\n  min-width: 110px;\r\n  font-weight: 600;\r\n  color: #1e88e5;\r\n}\r\n\r\n.news-text {\r\n  color: #333;\r\n}\r\n\r\n@keyframes scrollUp {\r\n  0% {\r\n    transform: translateY(0);\r\n  }\r\n  100% {\r\n    transform: translateY(-50%);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
